import httpManager from "@/app/shared/utils/httpManager";

export async function deactivateQueue(queue) {
  const url = `/queues/${queue.id}/`;
  const response = await httpManager.put(url, { status: 2 });
  return response.data;
}
